import React from 'react';
import PropTypes from 'prop-types';
import GridLoader from "react-spinners/GridLoader";
import { history } from '../../utils/utils';
import { loaderService } from './loader.service';
import './loader.scss'


const defaultProps = {
    visible: true
};

class Loader extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            visible: false
        };
    }

    componentDidMount() {
        // subscribe to new alert notifications
        this.subscription = loaderService.onShowHide(false)
            .subscribe(show => {
                // clear alerts when an empty alert is received
                this.setState({visible: show})
            });
            
    }


    componentWillUnmount() {
        // unsubscribe & unlisten to avoid memory leaks
        this.subscription.unsubscribe();
       // this.historyUnlisten();
    }

    

   

    render() {
       // const { alerts } = this.state;
        if (!this.state.visible) return null;
        return (
            <div className="overlay-loader-ui">
           <GridLoader
           margin={2}
          size={20}
          color={"#123abc"}
          loading={this.state.visible}
        />
          </div>
        );
    }
}

Loader.defaultProps = defaultProps;
export { Loader };